import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { 
    workUnitPrompt: String 
  }
  
  connect() {
    console.log('[WorkUnitSender] Controller connected')
    
    // Check if we have a work unit prompt to send
    if (this.hasWorkUnitPromptValue && this.workUnitPromptValue) {
      console.log('[WorkUnitSender] Found work unit prompt, sending to Claude Code')
      this.sendWorkUnit()
    } else {
      console.log('[WorkUnitSender] No work unit prompt found')
    }
  }
  
  sendWorkUnit() {
    const prompt = this.workUnitPromptValue
    console.log('[WorkUnitSender] Sending work unit, length:', prompt.length)
    
    // Try to find the task-execution controller
    const storyExecutionElement = document.querySelector('[data-controller~="task-execution"]')
    if (storyExecutionElement) {
      const application = window.Stimulus || (typeof Stimulus !== 'undefined' ? Stimulus : null)
      if (application && application.getControllerForElementAndIdentifier) {
        const controller = application.getControllerForElementAndIdentifier(storyExecutionElement, 'task-execution')
        if (controller && controller.sendToClaudeCode) {
          console.log('[WorkUnitSender] Found task-execution controller, delegating send')
          controller.sendToClaudeCode(prompt)
          controller.showNotification('Story execution started', 'success')
          
          // Clear the work unit prompt after sending
          this.workUnitPromptValue = ''
          return
        }
      }
    }
    
    console.log('[WorkUnitSender] Story-execution controller not found, trying direct send')
    this.sendDirectlyToClaudeCode(prompt)
  }
  
  sendDirectlyToClaudeCode(prompt) {
    // Switch to Claude Code tab first if available
    const claudeTab = document.querySelector('[data-tab="claude"]')
    if (claudeTab) {
      claudeTab.click()
      console.log('[WorkUnitSender] Switched to Claude tab')
      
      // Wait for tab switch
      setTimeout(() => {
        this.performDirectSend(prompt)
      }, 300)
    } else {
      this.performDirectSend(prompt)
    }
  }
  
  performDirectSend(prompt) {
    // Find Claude Code chat component
    const chatComponents = document.querySelectorAll('[data-controller*="claude-code-chat"]')
    console.log('[WorkUnitSender] Found', chatComponents.length, 'chat components')
    
    for (const chatComponent of chatComponents) {
      const messageInput = chatComponent.querySelector('[data-claude-code-chat-target*="input"]')
      if (messageInput && messageInput.offsetParent !== null) {
        console.log('[WorkUnitSender] Found visible input, setting value and dispatching event')
        
        // Set the value
        messageInput.value = prompt
        
        // Dispatch input event to trigger any listeners
        messageInput.dispatchEvent(new Event('input', { bubbles: true }))
        
        // Find and click send button
        const sendButton = chatComponent.querySelector('[data-action*="claude-code-chat#sendMessage"]')
        if (sendButton) {
          console.log('[WorkUnitSender] Clicking send button')
          sendButton.click()
        } else {
          // Try submitting the form
          const form = messageInput.closest('form')
          if (form) {
            console.log('[WorkUnitSender] Submitting form')
            form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }))
          }
        }
        
        // Show notification
        this.showNotification('Story sent to Claude Code', 'success')
        return
      }
    }
    
    console.error('[WorkUnitSender] Could not find Claude Code input')
    this.showNotification('Could not send to Claude Code - please check the Claude Code tab', 'error')
  }
  
  showNotification(message, type = 'info') {
    // Create toast notification
    const toast = document.createElement('div')
    toast.className = `toast toast-top toast-end`
    toast.innerHTML = `
      <div class="alert alert-${type}">
        <span>${message}</span>
      </div>
    `
    
    // Find or create toast container
    let toastContainer = document.querySelector('.toast-container')
    if (!toastContainer) {
      toastContainer = document.createElement('div')
      toastContainer.className = 'toast-container'
      document.body.appendChild(toastContainer)
    }
    
    toastContainer.appendChild(toast)
    
    // Remove after 3 seconds
    setTimeout(() => {
      toast.remove()
    }, 3000)
  }
}